import { type EmojiId } from '../common/structs/emoji/emoji';
export const emoji = () => ({
    collection: () => `/emoji_id`,
    extended: () => `/emoji_id/extended`,
    random: () => `/emoji_id/random`,
    search: () => `/emoji_id/search`,
    tags: (eid: EmojiId) => ({
        collection: () => `/emoji_id/${eid}`,
    }),
    // TODO: Should be renamed to `emojigroups`.
    groups: {
        check: (eid: EmojiId) => `/admin/groups/check/${eid}`,
    },
    rhythm: (eid: EmojiId) => `/emoji_id/${eid}/rhythm`,
    payment: (eid: EmojiId) => `/emoji_id/${eid}/payment`,
    lookup: (eid: EmojiId) => `/emoji_id/${eid}/metadata`,
});
